<template>
	<div class="page container">
		<div class="page__info">
			<div class="page__info--title">
				Admin
			</div>
		</div>

		<list-view :list="list" />

	</div>
</template>

<route>
	{
		"meta": {
			"isAdminOnly": true
		}
	}
</route>

<script>
	import ListView    from '@/components/ui/views/listView/ListView';

	export default {
		layout: 'v2default',
		metaInfo: {
			title: 'Admin'
		},
		components: {
			ListView
		},
		data: () => ({
			list: [
				{
					text: 'Users',
					route: '/admin/users'
				},
				{
					text: 'Courses',
					route: '/admin/courses'
				},
				{
					text: 'Deal Packs',
					route: '/admin/deal-packs'
				},
				{
					text: 'Knowledgebase',
					route: '/admin/knowledgebase'
				},
				{
					text: 'Focuses',
					route: '/admin/focuses'
				},
				{
					text: 'Keywords',
					route: '/admin/keywords'
				},
				{
					text: 'Approval queue',
					route: '/admin/queue'
				}
			]
		}),
		computed: {
			getBreadcrumbs () {
				return [
					{
						path: '/admin',
						text: 'Admin'
					}
				];
			}
		},
		created () {
			this.$store.commit('ui/setBreadcrumbs', {
				breadcrumbs: this.getBreadcrumbs
			});
			this.$store.commit('ui/setLoadingIsHidden');
		}
	};

</script>
